import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeRight20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconEdgeRight20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.5 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2M11 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4.4 2a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0zm-3.4 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0M2 13.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m9 3.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-9-7a1 1 0 1 0 2 0 1 1 0 0 0-2 0m5.5 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0M2 6.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeRight20);
